import { render, staticRenderFns } from "./ExerciseLogged.vue?vue&type=template&id=fee4659c&scoped=true&"
import script from "./ExerciseLogged.vue?vue&type=script&lang=js&"
export * from "./ExerciseLogged.vue?vue&type=script&lang=js&"
import style0 from "./ExerciseLogged.vue?vue&type=style&index=0&id=fee4659c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee4659c",
  null
  
)

export default component.exports